import { Chip } from "@mui/material"
import type { FC } from "react"

interface PaymentTermsDisplayProps {
  name: string
  value: string | number | null
}

export const PaymentTermsDisplay: FC<PaymentTermsDisplayProps> = ({ name, value }) => {
  return (
    <div className='flex flex-col items-start gap-1 [&:not(:last-child)]:mb-2'>
      <span className='text-sm text-gray-900'>{name}</span>
      {value && (
        <Chip
          label={value}
          variant='filled'
          size='small'
          className='max-w-full rounded-[4px] bg-primary-200 text-xs hover:bg-primary-300'
        />
      )}
    </div>
  )
}
